import _asyncToGenerator from "/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.starts-with.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.number.constructor.js";
import BookingModule from "@/store/modules/booking";
import { computed, defineComponent, ref, watch, watchEffect } from "vue";
import { useI18n } from "vue-i18n";
import NotificationService from "@/services/notification.service";
import { LogLevel, LogService } from "@/services/logging";
import editPen from "@/assets/images/svg/edit-pen-rectangle.svg";
import { Currencies } from "@/constants/currency";
import { AccountingState, PaymentMethods } from "@/types/db/accounting";
import ScannerModule from "@/store/modules/scanner";
import { extractCodeFromUrl, removeCodePayment } from "@/utils/vue-helpers/promocode";
import { handleVoucherPayment, initiateVoucherService } from "@/api/external-vouchers/incert";
import { ElMessageBox } from "element-plus";
import ExternalVouchersModule from "@/store/modules/external-vouchers";
import { VoucherService, VoucherValidity } from "@/interfaces/store/IExternalVouchersState";
import { isBookingInDexie } from "@/utils/helpers/booking";
export default defineComponent({
  name: "IncertVoucher",
  setup: function setup() {
    console.log("hi from IncertVoucher setup");

    var _useI18n = useI18n({}),
        t = _useI18n.t;

    var editPenIconStyle = "width: 30px; height: 30px";
    var editPenIconContent = editPen;
    var editPenIconAlt = "Edit";
    var voucherCode = ref(""
    /*getExistingPromocode()*/

    /*BookingModule.appliedPromocode*/
    );
    var isLoading = ref(false);
    var isPromocodeLengthValid = computed(function () {
      return voucherCode.value.length >= 5;
    });
    var currency = computed(function () {
      var _BookingModule$select;

      return ((_BookingModule$select = BookingModule.selectedBooking) === null || _BookingModule$select === void 0 ? void 0 : _BookingModule$select.currency) || Currencies.CHF;
    });
    var appliedVoucherInfos = computed(function () {
      var _BookingModule$select2;

      var voucherInfos = ExternalVouchersModule.getExternalVouchers;
      var appliedVouchersAccountings = (_BookingModule$select2 = BookingModule.selectedBooking) === null || _BookingModule$select2 === void 0 ? void 0 : _BookingModule$select2.accountings.filter(function (acc) {
        return acc.paymentMethod === PaymentMethods.EXTERNAL_INCERT_VOUCHER && (acc.state === AccountingState.Pending || acc.state === AccountingState.Completed);
      });

      if (appliedVouchersAccountings) {
        var codes = appliedVouchersAccountings.map(function (acc) {
          return acc.promocode;
        });
        return voucherInfos.filter(function (v) {
          return codes.includes(v.voucherCode);
        });
      }

      return [];
    }); // const paymentType = ref(PaymentMethods.POS_PROMO_CODE);

    var successMessage = ref("");
    var inputPlaceholder = String(t("promocode.enter")); // function updatePaymentType(type: PaymentMethods) {
    //   paymentType.value = type;
    // }

    function setSuccessMessage() {
      successMessage.value = t("promocode.voucher-applied");
    }

    var isEditOrder = ref(false);
    watchEffect( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!BookingModule.selectedBookingUUID) {
                _context.next = 4;
                break;
              }

              _context.next = 3;
              return isBookingInDexie(BookingModule.selectedBookingUUID);

            case 3:
              isEditOrder.value = _context.sent;

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));
    var scanPromocodeModal = ref(false);
    var ScannerTog = computed(function () {
      return ScannerModule.tog;
    });
    watch(ScannerTog, /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      var scannedValue, isUrl, code, scannedJsonCode;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (!(ScannerModule.value && scanPromocodeModal.value)) {
                _context2.next = 40;
                break;
              }

              LogService.info("Incert Voucher: scanner triggered, value = ".concat(ScannerModule.value)); // The scanned valued can be a json object (Locarno logic) and can be a url (old logic for everyone else)
              // Check if the voucherCode is a URL

              scannedValue = ScannerModule.value;
              isUrl = String(scannedValue).startsWith("http://") || String(scannedValue).startsWith("https://") || String(scannedValue).startsWith("http//") || String(scannedValue).startsWith("https//");

              if (!isUrl) {
                _context2.next = 18;
                break;
              }

              LogService.info("Incert Voucher: scanned value is in url format");
              console.log("Incert Voucher: scanned value is in url format"); // We keep the old logic of extracting the code from the url scanned

              code = extractCodeFromUrl(ScannerModule.value);
              LogService.info("Incert Voucher: extracted from qrcode string code: ".concat(code));

              if (!(code && code.length >= 5)) {
                _context2.next = 16;
                break;
              }

              voucherCode.value = code;
              LogService.info("Incert Voucher: going to process scanned voucher code: ".concat(voucherCode.value));
              _context2.next = 14;
              return applyIncertVoucher();

            case 14:
              LogService.info("Incert Voucher: Done processing scanned voucher code: ".concat(voucherCode.value));
              scanPromocodeModal.value = false;

            case 16:
              _context2.next = 40;
              break;

            case 18:
              LogService.info("Incert Voucher: scanned value is not in url format. Checking if it is json object."); // Check if the scanned value is actually a json object

              _context2.prev = 19;
              scannedJsonCode = JSON.parse(scannedValue);
              LogService.info("Incert Voucher: scanned value is in json format attached.", {
                params: scannedJsonCode
              }); // Check if it's in the expected format

              if (!(scannedJsonCode && scannedJsonCode.code && scannedJsonCode.token)) {
                _context2.next = 32;
                break;
              }

              LogService.info("Incert Voucher: scanned value is exactly in the expected format.", {
                params: scannedJsonCode
              }); // Lets proceed applying the code

              voucherCode.value = scannedJsonCode.code;
              LogService.info("Incert Voucher: going to process scanned voucher code: ".concat(voucherCode.value));
              _context2.next = 28;
              return applyIncertVoucher();

            case 28:
              LogService.info("Incert Voucher: Done processing scanned voucher code: ".concat(voucherCode.value));
              scanPromocodeModal.value = false;
              _context2.next = 34;
              break;

            case 32:
              LogService.info("Incert Voucher: scanned value is not in the expected format.", {
                params: scannedJsonCode
              }); // Lets notify the user that code couldn't be scanned

              NotificationService.showCustomMessage(t("promocode.could-not-scan"), "error");

            case 34:
              _context2.next = 40;
              break;

            case 36:
              _context2.prev = 36;
              _context2.t0 = _context2["catch"](19);
              // Couldn't parse the scanned value into a json object, this means the scanned value isn't a url and isn't a json obj, lets log
              LogService.info("Incert Voucher Error: scanned value is neither a url nor a valid json object: ".concat(voucherCode.value), {
                param: {
                  scannedValue: scannedValue,
                  err: _context2.t0
                }
              }, LogLevel.Error); // Lets notify the user that code couldn't be scanned

              NotificationService.showCustomMessage(t("promocode.could-not-scan"), "error");

            case 40:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[19, 36]]);
    })), {
      deep: true
    });

    function applyIncertVoucher() {
      return _applyIncertVoucher.apply(this, arguments);
    }

    function _applyIncertVoucher() {
      _applyIncertVoucher = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var _BookingModule$select3, _respData;

        var isVoucherExist, isVoucherPaymentsExist, filteredVoucherInfo, voucherLibObj, respData, resp, isNotValid, msg, isPartiallyRedeemable, _respData2, _respData3, _respData8, _respData9, _respData10, _respData11, statusName, voucherInfo;

        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                console.log("----- applyIncertVoucher -------");
                console.log("voucherCode:", voucherCode.value);
                isVoucherExist = ExternalVouchersModule.getExternalVouchers.find(function (v) {
                  return v.voucherCode === voucherCode.value;
                });
                isVoucherPaymentsExist = (_BookingModule$select3 = BookingModule.selectedBooking) === null || _BookingModule$select3 === void 0 ? void 0 : _BookingModule$select3.accountings.find(function (v) {
                  return (v.state === AccountingState.Pending || v.state === AccountingState.Completed) && v.promocode === voucherCode.value;
                });

                if (!(isVoucherExist && isVoucherPaymentsExist)) {
                  _context4.next = 8;
                  break;
                }

                return _context4.abrupt("return");

              case 8:
                if (isVoucherExist) {
                  // voucher exist in the state but has no payments, lets erase what is in the state and store the new data
                  filteredVoucherInfo = ExternalVouchersModule.getExternalVouchers.filter(function (v) {
                    return v.voucherCode !== voucherCode.value;
                  });

                  if (filteredVoucherInfo) {
                    ExternalVouchersModule.setExternalVouchers(filteredVoucherInfo);
                  } else {
                    ExternalVouchersModule.setExternalVouchers([]);
                  }
                }

              case 9:
                console.log("instantiating voucherLibrary");
                _context4.next = 12;
                return initiateVoucherService();

              case 12:
                voucherLibObj = _context4.sent;

                /**
                 * TODO HAMZA
                 * 1- checkStatus of the voucher to see if it is partially redeemable or not
                 * 2- If fully redeemable then show the user a popup to confirm the full consumption of the voucher even if orderTotal is less than voucher amount
                 * 3- If partially redeemable then
                 *    (a) Prepare data as IExternalVoucherRedemption
                 *    (b) Call library API to redeem the voucher
                 *    (c) If success then show the usual notification
                 *    (b) If error then show the usual notification with a new text based on the error
                 */
                isLoading.value = true;
                _context4.prev = 14;
                _context4.next = 17;
                return voucherLibObj.getVoucherStatus({
                  service: VoucherService.INCERT,
                  code: voucherCode.value
                });

              case 17:
                resp = _context4.sent;

                if (resp.data) {
                  _context4.next = 23;
                  break;
                }

                LogService.info("Incert Voucher Error: when checking code status", {
                  params: resp
                }, LogLevel.Error);
                NotificationService.showGeneralResponseError();
                isLoading.value = false;
                return _context4.abrupt("return");

              case 23:
                console.log("resp:", resp);
                respData = resp.data;
                _context4.next = 35;
                break;

              case 27:
                _context4.prev = 27;
                _context4.t0 = _context4["catch"](14);
                console.log("hi from catch");
                console.log(_context4.t0);
                LogService.info("Incert Voucher Error: when checking code status", {
                  params: _context4.t0
                }, LogLevel.Error); // NotificationService.showGeneralResponseError();

                NotificationService.showCustomError(t("error.no-internet")); // Lets log this error and return

                isLoading.value = false;
                return _context4.abrupt("return");

              case 35:
                console.log("respData:", respData);
                isNotValid = respData && (respData.status !== 1 || respData.remainingValue <= 0);

                if (!isNotValid) {
                  _context4.next = 56;
                  break;
                }

                msg = t("error.voucher-unkown");
                _context4.t1 = (_respData = respData) === null || _respData === void 0 ? void 0 : _respData.status;
                _context4.next = _context4.t1 === VoucherValidity.Canceled ? 42 : _context4.t1 === VoucherValidity.Expired ? 44 : _context4.t1 === VoucherValidity.FullyRedeemed ? 46 : _context4.t1 === VoucherValidity.NotFound ? 48 : _context4.t1 === VoucherValidity.Unknown ? 50 : 52;
                break;

              case 42:
                msg = t("error.voucher-canceled");
                return _context4.abrupt("break", 52);

              case 44:
                msg = t("error.voucher-expired");
                return _context4.abrupt("break", 52);

              case 46:
                msg = t("error.voucher-fully-redeemed");
                return _context4.abrupt("break", 52);

              case 48:
                msg = t("error.voucher-not-found");
                return _context4.abrupt("break", 52);

              case 50:
                msg = t("error.voucher-unkown");
                return _context4.abrupt("break", 52);

              case 52:
                if (respData && respData.status === 1 && respData.remainingValue <= 0) {
                  msg = t("error.voucher-fully-redeemed");
                }

                NotificationService.showCustomMessage(msg, "error");
                isLoading.value = false;
                return _context4.abrupt("return");

              case 56:
                isPartiallyRedeemable = respData && respData
                /*resp.data?*/
                .partiallyRedeemable && respData
                /*resp.data?*/
                .status === 1 && respData
                /*resp.data?*/
                .remainingValue > 0;
                console.log("isPartiallyRedeemable:", isPartiallyRedeemable);
                isLoading.value = false; // If not partially redeemable then show the user a popup to confirm the full consumption of the voucher even if orderTotal is less than voucher amount

                if (isPartiallyRedeemable) {
                  _context4.next = 65;
                  break;
                }

                console.log("showing msgBox");
                _context4.next = 63;
                return ElMessageBox.confirm(String(t("payment.incert-confirmation-popup")).replace("xxAmount", String((_respData2 = respData) === null || _respData2 === void 0 ? void 0 : _respData2.remainingValue)).replace("xxCurrency", String((_respData3 = respData) === null || _respData3 === void 0 ? void 0 : _respData3.currency)), {
                  type: "warning",
                  dangerouslyUseHTMLString: true,
                  customClass: "custom-message-box",
                  showClose: false,
                  closeOnClickModal: false,
                  closeOnPressEscape: false,
                  confirmButtonText: String(t("button.confirm")),
                  cancelButtonText: String(t("button.cancel"))
                }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
                  var _respData4, _respData5, _respData6, _respData7;

                  var statusName, voucherInfo;
                  return regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                      switch (_context3.prev = _context3.next) {
                        case 0:
                          LogService.info("User confirmed redeeming the none-partially redeemable voucher");
                          console.log("User confirmed redeeming the none-partially redeemable voucher"); // Lets now store the voucher info in ExternalVouchersModule

                          // Lets now store the voucher info in ExternalVouchersModule
                          statusName = VoucherValidity[Number((_respData4 = respData) === null || _respData4 === void 0 ? void 0 : _respData4.status)];
                          voucherInfo = {
                            voucherCode: voucherCode.value,
                            status: Number((_respData5 = respData) === null || _respData5 === void 0 ? void 0 : _respData5.status),
                            // Now we set statusName based on VoucherValidity enum
                            statusName: String(statusName),
                            originalRemainingValue: Number((_respData6 = respData) === null || _respData6 === void 0 ? void 0 : _respData6.remainingValue) * 100,
                            partiallyRedeemable: (_respData7 = respData) === null || _respData7 === void 0 ? void 0 : _respData7.partiallyRedeemable,
                            currency: Currencies.EUR,
                            orderSessionId: String(BookingModule.currentOrderSessionId),
                            currentSessionVoucherConsumption: 0,
                            voucherService: VoucherService.INCERT
                          };
                          ExternalVouchersModule.addExternalVouchers(voucherInfo);
                          LogService.info("Incert Voucher info added to the module", {
                            params: voucherInfo
                          }); // We will continue the flow as if the voucher is partially redeemable

                          // We will continue the flow as if the voucher is partially redeemable
                          isLoading.value = true;
                          handleVoucherPayment(voucherInfo); // await prepareOrderDataAndRedeem(voucherCode.value, voucherLibObj);

                          // await prepareOrderDataAndRedeem(voucherCode.value, voucherLibObj);
                          isLoading.value = false;

                        case 9:
                        case "end":
                          return _context3.stop();
                      }
                    }
                  }, _callee3);
                }))).catch(function () {
                  LogService.info("User stopped redeeming the none-partially redeemable voucher");
                  console.log("User stopped redeeming the none-partially redeemable voucher");
                  return;
                });

              case 63:
                _context4.next = 72;
                break;

              case 65:
                // Now lets continue the flow as if the voucher is partially redeemable or fully redeemable but user confirmed its full consumption
                isLoading.value = true; // Lets now store the voucher info in ExternalVouchersModule

                statusName = VoucherValidity[Number((_respData8 = respData) === null || _respData8 === void 0 ? void 0 : _respData8.status)];
                voucherInfo = {
                  voucherCode: voucherCode.value,
                  status: Number((_respData9 = respData) === null || _respData9 === void 0 ? void 0 : _respData9.status),
                  statusName: String(statusName),
                  originalRemainingValue: Number((_respData10 = respData) === null || _respData10 === void 0 ? void 0 : _respData10.remainingValue) * 100,
                  partiallyRedeemable: (_respData11 = respData) === null || _respData11 === void 0 ? void 0 : _respData11.partiallyRedeemable,
                  currency: Currencies.EUR,
                  orderSessionId: String(BookingModule.currentOrderSessionId),
                  currentSessionVoucherConsumption: 0,
                  voucherService: VoucherService.INCERT
                };
                ExternalVouchersModule.addExternalVouchers(voucherInfo);
                LogService.info("Incert Voucher info added to the module", {
                  params: voucherInfo
                });
                handleVoucherPayment(voucherInfo); // await prepareOrderDataAndRedeem(voucherCode.value, voucherLibObj);

                isLoading.value = false;

              case 72:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, null, [[14, 27]]);
      }));
      return _applyIncertVoucher.apply(this, arguments);
    }

    return {
      appliedVoucherInfos: appliedVoucherInfos,
      voucherCode: voucherCode,
      isLoading: isLoading,
      editPenIconStyle: editPenIconStyle,
      editPenIconContent: editPenIconContent,
      editPenIconAlt: editPenIconAlt,
      isPromocodeLengthValid: isPromocodeLengthValid,
      t: t,
      successMessage: successMessage,
      PaymentMethods: PaymentMethods,
      inputPlaceholder: inputPlaceholder,
      setSuccessMessage: setSuccessMessage,
      isEditOrder: isEditOrder,
      scanPromocodeModal: scanPromocodeModal,
      currency: currency,
      applyIncertVoucher: applyIncertVoucher,
      removeCodePayment: removeCodePayment
    };
  },
  methods: {
    openScanPromocodeModal: function openScanPromocodeModal() {
      this.scanPromocodeModal = true;
    }
  }
});